import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchEventById, fetchEvents } from '../../utils/api';
import config from '../../config';

function EventsDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [relatedEvents, setRelatedEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadEventData = async () => {
      setLoading(true);
      
      // Fetch current event
      const eventData = await fetchEventById(id);
      setEvent(eventData);
      
      // Fetch all events to get related ones
      const allEvents = await fetchEvents();
      
      // Filter upcoming events (excluding current one)
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const upcoming = allEvents.filter(
        e => e.id !== parseInt(id) && new Date(e.date) >= today
      );
      
      // Get 2 upcoming events
      setRelatedEvents(upcoming.slice(0, 2));
      
      setLoading(false);
    };
    
    loadEventData();
  }, [id]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      day: 'numeric', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  if (loading) {
    return <div className="container text-center py-5">Loading event details...</div>;
  }

  if (!event) {
    return <div className="container text-center py-5">Event not found</div>;
  }

  // Parse the images array
  const eventImages = event.images ? JSON.parse(event.images) : [];

  return (
    <div>
      <section className="page-header">
        <div 
          className="page-header-bg" 
          style={{ backgroundImage: `url(${config.baseUrl}/assets/images/backgrounds/Eventspageheader1894-434.jpg)` }}
        ></div>
        <div className="container">
          <div className="page-header__inner">
            <h2>Event Details</h2>
            <ul className="thm-breadcrumb list-unstyled">
              <li><a href="/">Home</a></li>
              <li><span>/</span></li>
              <li><a href="/blogs">Events</a></li>
              <li><span>/</span></li>
              <li><a href="">{event.title}</a></li>
            </ul>
          </div>
        </div>
      </section>
      
      <section className="blog-details">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-7">
              <div className="blog-details__left">
                <div className="blog-details__img">
                  <img 
                    src={`https://backoffice.rohautism.org/uploads/${event.main_image}`} 
                    alt={event.title} 
                  />
                  <div className="blog-details__date">
                    <p>{new Date(event.date).getDate()}<br /> 
                    {new Date(event.date).toLocaleString('default', { month: 'short' })}</p>
                  </div>
                </div>
                <div className="blog-details__content">
                  <ul className="blog-details__meta list-unstyled">
                    <li>
                      <a href="#"><i className="fas fa-calendar"></i>{formatDate(event.date)}</a>
                    </li>
                    {event.registration_link && (
                      <li>
                        <a href={event.registration_link} target="_blank" rel="noopener noreferrer">
                          <i className="fas fa-link"></i>Register Now
                        </a>
                      </li>
                    )}
                  </ul>
                  <h3 className="blog-details__title">{event.title}</h3>
                  <div className="blog-details__text-1">
  {event.description.split('\r\n\r\n').map((paragraph, index) => (
    <div 
      key={index} 
      dangerouslySetInnerHTML={{ __html: paragraph }} 
    />
  ))}
</div>
                  
                  {/* Display additional images if available */}
                  {eventImages.length > 0 && (
                    <div className="row mt-4">
                      {eventImages.map((image, index) => (
                        <div key={index} className="col-md-4 mb-3">
                          <img 
                            src={`https://backoffice.rohautism.org/uploads/${image}`} 
                            alt={`Event ${index + 1}`} 
                            className="img-fluid"
                          />
                        </div>
                      ))}
                    </div>
                  )}
                  
                  <div className="blog-details__bottom"></div>
                  
                  {/* Related Events */}
                  {relatedEvents.length > 0 && (
                    <div className="blog-details__pagenation">
                      <h4 className="mb-4">Upcoming Events</h4>
                      <div className="row">
                        {relatedEvents.map(relatedEvent => (
                          <div key={relatedEvent.id} className="col-md-12">
                            <div 
                              className="blog-details__pagenation-left cursor-pointer"
                              onClick={() => navigate(`/event-details/${relatedEvent.id}`)}
                            >
                              <div className="blog-details__pagenation-left-img">
                                <img 
                                  src={`https://backoffice.rohautism.org/uploads/${relatedEvent.main_image}`} 
                                  alt={relatedEvent.title} 
                                />
                              </div>
                              <div className="blog-details__pagenation-left-content">
                                <p className="blog-details__pagenation-left-date">
                                  <i className="fas fa-clock"></i>
                                  {formatDate(relatedEvent.date)}
                                </p>
                                <h4 className="blog-details__pagenation-left-title">
                                  <a 
                                    href={`/event-details/${relatedEvent.id}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      navigate(`/event-details/${relatedEvent.id}`);
                                    }}
                                  >
                                    {relatedEvent.title}
                                  </a>
                                </h4>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default EventsDetails;